import { Puja } from 'components';

const PujaPage = () => {
	return <Puja />;
};

export default PujaPage;
